import React from 'react';
import {StyleSheet, View} from 'react-native';

import theme from '../style/theme';

import DropDownPicker from './ui-controls/DropDownPicker';
import TextInput from './ui-controls/form/TextInput';
import Text from './ui-controls/Text';

function PromotionCaptureExtraUserInputText({inputSpec, onValueChanged}) {
  return (
    <TextInput
      placeholder={inputSpec.placeholder}
      onChangeText={onValueChanged}
      maxLength={inputSpec.maxLength}
    />
  );
}

function PromotionCaptureExtraUserInputSelect({inputSpec, onValueChanged}) {
  if (!inputSpec.items) return null;

  return (
    <DropDownPicker
      items={inputSpec.items}
      placeholder={inputSpec.placeholder}
      onSelectItem={onValueChanged}
    />
  );
}

export default function PromotionCaptureExtraUserInput({
  extraUserInputSpec,
  onExtraUserInputChanged,
}) {
  const handleValueChanged = value => onExtraUserInputChanged(value);

  let UserInputComponent = null;
  switch (extraUserInputSpec.type) {
    case 'select':
      UserInputComponent = PromotionCaptureExtraUserInputSelect;
      break;
    case 'text':
      UserInputComponent = PromotionCaptureExtraUserInputText;
      break;
  }
  if (!UserInputComponent) return null;

  return (
    <View style={styles.section}>
      {!!extraUserInputSpec.title && (
        <Text style={styles.title}>{extraUserInputSpec.title}</Text>
      )}
      {!!extraUserInputSpec.description && (
        <Text style={styles.description}>{extraUserInputSpec.description}</Text>
      )}
      <UserInputComponent
        inputSpec={extraUserInputSpec}
        onValueChanged={handleValueChanged}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  section: {
    paddingVertical: 5,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    paddingBottom: 2,
    color: theme.colour.text.heading.primary,
  },
  description: {
    paddingBottom: 4,
    fontSize: 16,
    color: theme.colour.text.content.primary,
  },
});
